export default __webpack_public_path__ + "static/media/activate-quick-play.bebf4256.mp3";